import React from 'react';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
const ModalStateless = ({ component: Component, header, hasHeader, onClose, open, size, ...rest }) => (<Dialog open={open} onClose={onClose} fullWidth maxWidth={size} {...rest}>
    {hasHeader && (<>
          <DialogTitle>{header}</DialogTitle>
          <Divider />
        </>)}
    {Component}
  </Dialog>);
export default ModalStateless;
